import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/api.models';
import { Language } from '../models/language.models';

@Injectable({ providedIn: 'root' })
export class LanguageApiService {
  readonly #http = inject(HttpClient);
  readonly #baseUrl = `${environment.apiBaseUrl}/languages`;

  indexAll(): Observable<Language[]> {
    return this.#http
      .get<ApiResponse<Language[]>>(this.#baseUrl)
      .pipe(map((response) => response.data));
  }
}
